import { render } from "./SettingsPage.vue?vue&type=template&id=600d250a&scoped=true&ts=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPage.vue?vue&type=script&lang=ts&setup=true"

import "./SettingsPage.vue?vue&type=style&index=0&id=600d250a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600d250a"],['__file',"src/pages/settings/SettingsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "600d250a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('600d250a', __exports__)) {
    api.reload('600d250a', __exports__)
  }
  
  module.hot.accept("./SettingsPage.vue?vue&type=template&id=600d250a&scoped=true&ts=true", () => {
    api.rerender('600d250a', render)
  })

}


export default __exports__